import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const STORAGE_KEY = 'topNotificationDismissed';

const TopNotification = ({ messageId, children, className = '' }) => {
    const [visible, setVisible] = useState(false);
    const location = useLocation();
    const lastPathRef = useRef(location.pathname);

    useEffect(() => {
        try {
            const dismissedRaw = localStorage.getItem(STORAGE_KEY);
            const dismissed = dismissedRaw ? JSON.parse(dismissedRaw) : {};
            setVisible(dismissed[messageId] !== true);
        } catch (e) {
            setVisible(true);
        }
    }, [messageId]);

    // Hide notification when route changes (but not on initial mount)
    useEffect(() => {
        if (lastPathRef.current !== location.pathname) {
            setVisible(false);
        }
        lastPathRef.current = location.pathname;
    }, [location.pathname]);

    const handleClose = () => {
        try {
            const dismissedRaw = localStorage.getItem(STORAGE_KEY);
            const dismissed = dismissedRaw ? JSON.parse(dismissedRaw) : {};
            dismissed[messageId] = true;
            localStorage.setItem(STORAGE_KEY, JSON.stringify(dismissed));
        } catch (e) {}
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className={`top-notification ${className}`}>            
            <div className="top-notification__content">
                {children}
            </div>
            <button type="button" className="top-notification__close" onClick={handleClose} aria-label="close">
                ×
            </button>
        </div>
    );
}

export default TopNotification;


